<template>
  <div id="receiptData">
    <body style="font-size: 12pt">
      <div id="page-wrap">
        <v-row class="d-none d-sm-flex" v-if="modulename == 'Purchases'">
          <v-col cols="4" lg="4" md="12">
            <v-card style="background-color: #005985">
              <v-row style="color: white">
                <v-col cols="6" lg="5" sm="6" md="5" class="ml-4 p-100"
                  >Total Amount</v-col
                >
                <v-col
                  cols="6"
                  lg="6"
                  sm="5"
                  md="6"
                  class="text-lg-right font-weight-bold"
                >
                  {{ purchaseTotal | formatCurrency }}</v-col
                >
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="4" lg="4" md="12">
            <v-card style="background-color: #005985">
              <v-row style="color: white">
                <v-col cols="6" lg="5" sm="6" md="5" class="ml-4 p-100"
                  >Discount Amount</v-col
                >
                <v-col
                  cols="6"
                  lg="6"
                  sm="5"
                  md="6"
                  class="text-lg-right font-weight-bold"
                >
                  {{ discountTotal | formatCurrency }}</v-col
                >
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="4" lg="4" md="12">
            <v-card style="background-color: #005985">
              <v-row style="color: white">
                <v-col cols="6" lg="5" sm="6" md="5" class="ml-4 p-100"
                  >Paid Amount</v-col
                >
                <v-col
                  cols="6"
                  lg="6"
                  sm="5"
                  md="6"
                  class="text-lg-right font-weight-bold"
                >
                  {{ purchasePaid | formatCurrency }}</v-col
                >
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="d-none d-sm-flex" v-if="modulename == 'Sales'">
          <v-col cols="4" lg="4" md="12">
            <v-card style="background-color: #005985">
              <v-row style="color: white">
                <v-col cols="6" lg="5" sm="6" md="5" class="ml-4 p-100"
                  >Total Amount</v-col
                >
                <v-col
                  cols="6"
                  lg="6"
                  sm="5"
                  md="6"
                  class="text-lg-right font-weight-bold"
                >
                  {{ salesTotal | formatCurrency }}</v-col
                >
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="4" lg="4" md="12">
            <v-card style="background-color: #005985">
              <v-row style="color: white">
                <v-col cols="6" lg="5" sm="6" md="5" class="ml-4 p-100"
                  >Discount Amount</v-col
                >
                <v-col
                  cols="6"
                  lg="6"
                  sm="5"
                  md="6"
                  class="text-lg-right font-weight-bold"
                >
                  {{ salesDiscount | formatCurrency }}</v-col
                >
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="4" lg="4" md="12">
            <v-card style="background-color: #005985">
              <v-row style="color: white">
                <v-col cols="6" lg="5" sm="6" md="5" class="ml-4 p-100"
                  >Net Amount</v-col
                >
                <v-col
                  cols="6"
                  lg="6"
                  sm="5"
                  md="6"
                  class="text-lg-right font-weight-bold"
                >
                  {{ salesNet | formatCurrency }}</v-col
                >
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <!-- <v-row
          class="d-none d-sm-flex"
          v-if="
            modulename == 'Product Transfer Report Product Management' ||
              modulename == 'Shop Stock Report Product Management' ||
              modulename == 'Sales Product Management Report'
          "
        >
          <v-col cols="4" lg="4" md="12"> </v-col>
          <v-col cols="4" lg="4" md="12"> </v-col>
          <v-col cols="4" lg="4" md="12"> </v-col>
          <v-row>
            <v-col cols="6" sm="6" lg="1" md="1"> </v-col>
            <v-col cols="6" sm="6" lg="2" md="2">
              {{ filterDatas.productquery ? "Product Name :" : "" }}
            </v-col>
            <v-col cols="6" sm="6" lg="3" md="3">
              {{ filterDatas.productquery }}
            </v-col>
            <v-col cols="6" sm="6" lg="3" md="3">
              {{ filterDatas.shopquery ? "Shop Name :" : "" }}
            </v-col>
            <v-col cols="6" sm="6" lg="3" md="3">
              {{ filterDatas.shopquery }}
            </v-col>
          </v-row>
        </v-row> -->
        <!-- {{filterDats}} -->
        <!-- <div v-for="item in filterDats">

<v-row v-if="item.value">
  <v-col>
    {{item.name}}
  </v-col>
  <v-col>
    {{item.value}}
  </v-col>
</v-row>

</div> -->
        <div class="pt-3"></div>
        <v-card class="pa-4">
          <div v-for="item in filterDats">
            <div v-if="item.value">
              <v-row my="5">
                <v-col cols="2" sm="2" lg="2" md="2"> {{ item.name }} : </v-col>
                <v-col cols="2" sm="2" lg="2" md="2">{{ item.value }}</v-col>
              </v-row>
            </div>
          </div>

          <div v-if="!noDataVisible">
            <table class="table" style="margin: auto">
              <thead>
                <tr>
                  <th :colspan="headers.length">
                    <div style="color: black">
                      <h2>
                        {{ modulename }}
                      </h2>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="(item, index) in headers" :key="item.text">
                    {{ item.text }}
                  </td>
                </tr>

                <tr v-for="(item1, index1) in items" :key="item1.id">
                  <td v-for="(item, index2) in headers" :key="item.text">
                    <div
                      :class="
                        item.text == 'Total' ||
                        item.text == 'Paid' ||
                        item.text == 'Total Amount' ||
                        item.text == 'Discount Amount' ||
                        item.text == 'Net Amount' ||
                        item.text == 'Due Amount' ||
                        item.text == 'Payment Amount' ||
                        item.text == 'Min Price' ||
                        item.text == 'Amount' ||
                        item.text == 'Grand Total' ||
                        item.text == 'Discount'
                          ? 'text-right'
                          : ''
                      "
                    >
                      {{ item.render(item1) }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <noData
              class="mt-10 container justify-center item-center"
              name="Data"
            />
          </div>
        </v-card>
        <p style="page-break-after: auto"></p>

        <p style="page-break-after: always"></p>
      </div>
    </body>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import noData from '../../../components/shared/noItem.vue';

export default {
  data() {
    return {
      ReservationDetails: [],
      bottombarVisible: false,
    };
  },
  mounted() {
    if (this.filterDats) {
      // Todo
    }
  },
  computed: {
    ...mapState(['imagelink']),

    ...mapState(['filterDatas']),
  },
  props: {
    modulename: {
      type: String,
      default: 'Products',
    },
    filterDats: {
      type: Object,
      default: {},
    },
    headers: {
      type: Object,
      default: [],
    },
    shopVisible: {
      type: Boolean,
      default: false,
    },
    purchaseTotal: {
      type: Number,
      default: 0,
    },
    discountTotal: {
      type: Number,
      default: 0,
    },
    purchasePaid: {
      type: Number,
      default: 0,
    },
    salesTotal: {
      type: Number,
      default: 0,
    },
    salesNet: {
      type: Number,
      default: 0,
    },
    salesDiscount: {
      type: Number,
      default: 0,
    },

    items: {
      type: Array,
      default: [],
    },

    noDataVisible: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    print() {
      this.$htmlToPaper('receiptData');
    },
  },

  components: {
    noData,
  },
};
</script>
<style scoped>
table {
  margin: 40px 0px;
  font-size: 1rem;
  color: #333;
  font-weight: 700;
  border: 1px solid #ccc;
  background-color: #fff;
  width: 100%;
  text-align: center;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
}

table thead {
  background-color: #ccc;
  font-size: 2rem;
  color: #fff;
  letter-spacing: 0.3rem;
}

table td,
table th {
  border-bottom: 1px solid #ccc !important;
  height: 25px;
  vertical-align: middle !important;
}

table thead th + th,
table tbody td {
  border-right: 1px solid #ccc !important;
}

/* table tbody td:nth-child(6) {
  border-right: none;
  text-align: left;
} */

table tbody tr:nth-child(1) {
  color: rgb(0, 0, 0);
  font-size: 16px;
}

table th {
  font-size: 12px;
}

table td,
table th {
  height: 25px;
}

tr:hover {
  background: #e3f2fd;
}
</style>
